// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Avatar,
//   Dialog,
//   DialogContent,
//   Button,
// } from "@mui/material";

// const ImageTable2 = ({ data }) => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [openModal, setOpenModal] = useState(false);

//   const handleOpenModal = (image) => {
//     setSelectedImage(image);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//   };

//   const handleRotateImage = () => {
//     // Rotate the image logic here
//     // Example: You can rotate the image using CSS classes
//     const imgElement = document.getElementById("selected-image");
//     if (imgElement) {
//       imgElement.style.transform = "rotate(90deg)";
//     }
//   };

//   return (
//     <>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Name</TableCell>
//               <TableCell>Email</TableCell>
//               <TableCell>Image</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {data.map((row, index) => (
//               <TableRow key={index}>
//                 <TableCell>{row.name}</TableCell>
//                 <TableCell>{row.email}</TableCell>
//                 <TableCell>
//                   <Avatar
//                     alt={row.name}
//                     src={row.image}
//                     onClick={() => handleOpenModal(row.image)}
//                     sx={{ width: 100, height: 100 }} // Set width and height for the Avatar
//                   />
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Dialog open={openModal} onClose={handleCloseModal}>
//         <DialogContent>
//           <Avatar
//             alt="Selected Image"
//             src={selectedImage}
//             id="selected-image" // Set an ID for the image
//             sx={{ width: "100%", height: "auto", borderRadius: "50%" }} // Set width and height for the Avatar
//           />
//           <Button onClick={handleRotateImage}>Rotate</Button>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default ImageTable2;

// import React from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Avatar,
// } from "@mui/material";

// const ImageTable2 = ({ data }) => {
//   return (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Name</TableCell>
//             <TableCell>Email</TableCell>
//             <TableCell>Image</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {data.map((row, index) => (
//             <TableRow key={index}>
//               <TableCell>{row.name}</TableCell>
//               <TableCell>{row.email}</TableCell>
//               <TableCell>
//                 <Avatar alt={row.name} src={row.image} />
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default ImageTable2;

import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
  Modal,
  Box,
  Stack,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";

function ImageTable2({ data }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [rotation, setRotation] = useState(0);

  const handleOpen = (imgLink) => {
    setModalImage(imgLink);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setRotation(0);
  };

  const rotateLeft = () => setRotation((prev) => prev - 90);
  const rotateRight = () => setRotation((prev) => prev + 90);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {/* <TableCell
                sx={{
                  color: "blue",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                S.No
              </TableCell> */}
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Document No
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Front
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Back
              </TableCell>
              {/* <TableCell
                sx={{
                  color: "blue",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                View
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody sx={{ height: 10 }}>
            {data.length > 0 &&
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover key={index}>
                    <TableCell sx={{ padding: "10px" }}>
                      {/* {page * rowsPerPage + index + 1} */}
                      {row.DocumentNo}
                    </TableCell>
                    {/* <TableCell sx={{ padding: "0px" }}>
                    {row.ImagePath1}
                  </TableCell> */}
                    <TableCell sx={{ padding: "0px" }}>
                      <IconButton onClick={() => handleOpen(row.ImagePath1)}>
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{ padding: "0px" }}>
                      <IconButton onClick={() => handleOpen(row.ImagePath1)}>
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={modalImage}
            alt="Modal Display"
            style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
          />
          <Stack sx={{ display: "flex", flexDirection: "row" }}>
            <IconButton onClick={rotateLeft}>
              <RotateLeftIcon />
            </IconButton>
            <IconButton onClick={rotateRight}>
              <RotateRightIcon />
            </IconButton>
          </Stack>
        </Box>
      </Modal>
    </Paper>
  );
}

export default ImageTable2;
